import { render } from "./CustomPage.vue?vue&type=template&id=78dcc255"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__